import { render, staticRenderFns } from "./doctorSalaryBill.vue?vue&type=template&id=2144db59&scoped=true"
import script from "./doctorSalaryBill.vue?vue&type=script&lang=js"
export * from "./doctorSalaryBill.vue?vue&type=script&lang=js"
import style0 from "./doctorSalaryBill.vue?vue&type=style&index=0&id=2144db59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144db59",
  null
  
)

export default component.exports